<template>
  <div class="flex justify-center">
    <span
      class="rounded-md inline-flex items-center gap-4 bg-[#001550] px-6 py-4"
    >
      <IconBackMarket class="text-[#E2F77E]" size="24" />
      <span class="text-static-default-hi mood-inverse body-2-bold">
        {{ i18n(translations.tag) }}
      </span>
    </span>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconBackMarket } from '@ds/icons/IconBackMarket'

import translations from './WarrantyTag.translations'

const i18n = useI18n()
</script>
